// shared/lib/tokens/env.token.ts
import { InjectionToken } from '@angular/core';

export interface Environment {
    production: boolean;
    URL_MAPPING: {
      PROJ_API: string;
      USERMGMT_API: string;
      GITHUB_APIURL: string;
      GITHUB_TOKEN: string;
      GOOGLE_FONTS_API_KEY: string;
      UNIAPP_ICONRUL: string;
      KEYSTORE_URL: string;
    };
    ENV: string;
    KEYCLOAK_URLS: {
      BASE_URL: string;
      REDIRECT_URL: string;
      LOGOUT_URL: string;
    };
    CLIENT_ID: string;
    REALM_NAME: string;
  }

// Replace `any` with a proper interface for your env shape if you like
export const ENV_CONFIG = new InjectionToken<Environment>('ENV_CONFIG');
